/**
 * NOTE: Following features are present in the back office but absent here as constants - new_csv_export, margin_of_error.
 * */
export const FEATURES = {
  CHART_AVERAGE_2: 'chart_average_2',
  COMPETITORS: 'organisation_profile',
  HIDE_POPULATION_NUMBERS: 'hide_population_numbers', // Specific for a Turo customer
  ENABLE_POPULATION_NUMBERS: 'enable_population_numbers',
  MATRIX_CHART: 'matrix_chart',
  BRAND_FUNNEL_CHART: 'brand_funnel_chart',
  SHOW_CHART_FILTERS_ON_DASHBOARD: 'show_chart_filters_on_dashboard',
  AI_CHAT_BOT: 'ai_chat_bot',
  CUSTOM_KPIS: 'custom_kpis',
  ADVANCED_CSV_EXPORT: 'advanced_csv_export', // [advanced] csv export will be used only for Emma Sleep.
  CUSTOMER_DATA_EXPORT: 'customer_data_export',
};
